(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('shipping-countdown')) {
    class ShippingCountdown extends HTMLElement {
      connectedCallback() {
        this.message = this.querySelector('[data-b2c-shipping-message]');
        this.productRoot = this.closest('.js-product') || document;
        this.variants = this.readVariants();
        this.variantMap = new Map(this.variants.map((variant) => [String(variant.id), variant]));
        this.cutoffHour = Number(this.dataset.cutoffHour || 18);
        this.timeZone = this.dataset.timezone || 'Europe/Amsterdam';
        this.isPreorder = this.dataset.isPreorder === 'true';
        this.showAfterCutoff = this.dataset.showAfterCutoff !== 'false';
        this.countdownLabel = this.dataset.countdownLabel || 'VANDAAG VERSTUURD? JE HEBT NOG:';
        this.afterCutoffLabel = this.dataset.afterCutoffLabel || 'MORGEN VERSTUURD';
        this.weekendLabel = this.dataset.weekendLabel || 'MAANDAG VERSTUURD';

        this.handlePotentialVariantChange = () => {
          window.setTimeout(() => this.update(), 0);
        };

        this.productRoot.addEventListener('change', this.handlePotentialVariantChange, true);
        this.productRoot.addEventListener('on:variant:change', this.handlePotentialVariantChange);
        this.productRoot.addEventListener('variant:change', this.handlePotentialVariantChange);

        this.update();
        this.timer = window.setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);

        if (this.productRoot && this.handlePotentialVariantChange) {
          this.productRoot.removeEventListener('change', this.handlePotentialVariantChange, true);
          this.productRoot.removeEventListener('on:variant:change', this.handlePotentialVariantChange);
          this.productRoot.removeEventListener('variant:change', this.handlePotentialVariantChange);
        }
      }

      readVariants() {
        const script = this.querySelector('[data-b2c-shipping-variants]');
        if (!script) return [];

        try {
          return JSON.parse(script.textContent.trim());
        } catch (error) {
          console.warn('Bar2Charge verzendtimer: variantgegevens konden niet worden gelezen.', error);
          return [];
        }
      }

      getSelectedVariantId() {
        const mainForm = this.productRoot.querySelector('form.js-product-form-main');
        const idInput = mainForm && mainForm.querySelector('input[name="id"]');

        if (idInput && idInput.value) return String(idInput.value);

        const urlVariant = new URL(window.location.href).searchParams.get('variant');
        if (urlVariant) return String(urlVariant);

        return String(this.dataset.initialVariantId || '');
      }

      selectedVariantIsInStock() {
        if (this.isPreorder) return false;

        const variant = this.variantMap.get(this.getSelectedVariantId());
        if (!variant || variant.available !== true) return false;

        if (
          variant.specialDelivery &&
          String(variant.specialDelivery).trim() !== '' &&
          Number(variant.inventoryQuantity) <= 0
        ) {
          return false;
        }

        if (variant.inventoryManagement && Number(variant.inventoryQuantity) <= 0) {
          return false;
        }

        return true;
      }

      getAmsterdamTimeParts(date) {
        const formatter = new Intl.DateTimeFormat('en-GB', {
          timeZone: this.timeZone,
          weekday: 'short',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hourCycle: 'h23'
        });

        return formatter.formatToParts(date).reduce((parts, part) => {
          if (part.type !== 'literal') parts[part.type] = part.value;
          return parts;
        }, {});
      }

      getWeekdayNumber(shortWeekday) {
        return { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 }[shortWeekday] || 0;
      }

      formatDuration(totalSeconds) {
        const safeSeconds = Math.max(0, totalSeconds);
        const hours = Math.floor(safeSeconds / 3600);
        const minutes = Math.floor((safeSeconds % 3600) / 60);
        const seconds = safeSeconds % 60;

        return [hours, minutes, seconds]
          .map((value) => String(value).padStart(2, '0'))
          .join(':');
      }

      escapeHtml(value) {
        const element = document.createElement('div');
        element.textContent = value;
        return element.innerHTML;
      }

      showCountdown(secondsRemaining) {
        this.message.innerHTML =
          `<strong>${this.escapeHtml(this.countdownLabel)}</strong> ` +
          `<span class="b2c-shipping-countdown__time">${this.formatDuration(secondsRemaining)}</span>`;
        this.hidden = false;
      }

      showStatus(label) {
        if (!this.showAfterCutoff) {
          this.hidden = true;
          return;
        }

        this.message.innerHTML = `<strong>${this.escapeHtml(label)}</strong>`;
        this.hidden = false;
      }

      update() {
        if (!this.message || !this.selectedVariantIsInStock()) {
          this.hidden = true;
          return;
        }

        const parts = this.getAmsterdamTimeParts(new Date());
        const weekday = this.getWeekdayNumber(parts.weekday);
        const currentSeconds = Number(parts.hour) * 3600 + Number(parts.minute) * 60 + Number(parts.second);
        const cutoffSeconds = this.cutoffHour * 3600;
        const isWeekday = weekday >= 1 && weekday <= 5;

        if (isWeekday && currentSeconds < cutoffSeconds) {
          this.showCountdown(cutoffSeconds - currentSeconds);
          return;
        }

        if (weekday === 5 || weekday === 6 || weekday === 7) {
          this.showStatus(this.weekendLabel);
          return;
        }

        this.showStatus(this.afterCutoffLabel);
      }
    }

    customElements.define('shipping-countdown', ShippingCountdown);
  }


  if (!customElements.get('b2c-warranty-choice')) {
    class B2CWarrantyChoice extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.form = this.closest('form');
        this.productRoot = this.closest('.js-product') || document;
        this.radios = Array.from(this.querySelectorAll('.b2c-warranty-choice__radio'));
        this.totalElement = this.querySelector('[data-b2c-warranty-total]');
        this.summaryElement = this.querySelector('[data-b2c-warranty-summary]');
        this.variants = this.readVariants();
        this.variantMap = new Map(this.variants.map((variant) => [String(variant.id), variant]));

        if (!this.form || this.radios.length === 0) return;

        this.handleUpdate = () => window.requestAnimationFrame(() => this.updateTotal());
        this.handleSubmit = (event) => this.submitWithWarranty(event);

        this.radios.forEach((radio) => radio.addEventListener('change', this.handleUpdate));
        this.form.addEventListener('input', this.handleUpdate);
        this.form.addEventListener('change', this.handleUpdate);
        this.form.addEventListener('submit', this.handleSubmit, true);
        this.productRoot.addEventListener('on:variant:change', this.handleUpdate);
        this.productRoot.addEventListener('variant:change', this.handleUpdate);

        this.updateTotal();
      }

      disconnectedCallback() {
        if (!this.form || !this.handleUpdate) return;

        this.radios.forEach((radio) => radio.removeEventListener('change', this.handleUpdate));
        this.form.removeEventListener('input', this.handleUpdate);
        this.form.removeEventListener('change', this.handleUpdate);
        this.form.removeEventListener('submit', this.handleSubmit, true);
        this.productRoot.removeEventListener('on:variant:change', this.handleUpdate);
        this.productRoot.removeEventListener('variant:change', this.handleUpdate);
      }

      readVariants() {
        const script = this.querySelector('[data-b2c-warranty-product-variants]');
        if (!script) return [];

        try {
          return JSON.parse(script.textContent.trim());
        } catch (error) {
          console.warn('Bar2Charge ChargeCare: productprijzen konden niet worden gelezen.', error);
          return [];
        }
      }

      getSelectedRadio() {
        return this.radios.find((radio) => radio.checked) || this.radios[0];
      }

      getSelectedVariantId() {
        const idInput = this.form.querySelector('input[name="id"]');
        return idInput && idInput.value ? String(idInput.value) : '';
      }

      getQuantity() {
        const quantityInput = this.form.querySelector('[name="quantity"]');
        const quantity = quantityInput ? Number.parseInt(quantityInput.value, 10) : 1;
        return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
      }

      formatMoney(cents) {
        const currency = this.dataset.currency || 'EUR';
        const locale = this.dataset.locale || 'nl-NL';

        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency
          }).format(Number(cents || 0) / 100);
        } catch (error) {
          return `${(Number(cents || 0) / 100).toFixed(2)} ${currency}`;
        }
      }

      updateTotal() {
        const productVariant = this.variantMap.get(this.getSelectedVariantId());
        const selectedRadio = this.getSelectedRadio();
        const warrantyPrice = Number(selectedRadio?.dataset.price || 0);
        const productPrice = Number(productVariant?.price || 0);
        const quantity = this.getQuantity();

        if (this.totalElement) {
          this.totalElement.textContent = this.formatMoney((productPrice + warrantyPrice) * quantity);
        }

        if (this.summaryElement) {
          const baseSummary = selectedRadio?.dataset.summary || 'Product met standaard garantie';
          this.summaryElement.textContent = quantity > 1 ? `${baseSummary} × ${quantity}` : baseSummary;
        }
      }

      collectMainItem() {
        const formData = new FormData(this.form);
        const variantId = Number(formData.get('id'));
        const quantity = this.getQuantity();
        const properties = {};

        for (const [key, value] of formData.entries()) {
          const propertyMatch = key.match(/^properties\[(.*)\]$/);
          if (propertyMatch && String(value).trim() !== '') {
            properties[propertyMatch[1]] = value;
          }
        }

        const item = {
          id: variantId,
          quantity
        };

        if (Object.keys(properties).length > 0) {
          item.properties = properties;
        }

        const sellingPlan = formData.get('selling_plan');
        if (sellingPlan) {
          item.selling_plan = Number(sellingPlan);
        }

        return item;
      }

      showError(message) {
        const errorElement = this.form.querySelector('.js-form-error');
        if (!errorElement) return;

        errorElement.textContent = message;
        errorElement.hidden = false;
      }

      setLoading(isLoading) {
        const button = this.form.querySelector('button[name="add"]');
        if (!button) return;

        button.disabled = isLoading;
        button.toggleAttribute('aria-busy', isLoading);
      }

      async submitWithWarranty(event) {
        const selectedRadio = this.getSelectedRadio();
        const warrantyVariantId = Number(selectedRadio?.value || 0);

        if (!warrantyVariantId) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const mainItem = this.collectMainItem();
        if (!mainItem.id) {
          this.showError('Kies eerst een productuitvoering.');
          return;
        }

        const selectedProductVariant = this.variantMap.get(String(mainItem.id));
        const warrantyProperties = {
          'Garantie voor': this.dataset.productTitle || document.title,
          'ChargeCare': selectedRadio.dataset.title || 'Verlengde garantie'
        };

        if (selectedProductVariant?.title && selectedProductVariant.title !== 'Default Title') {
          warrantyProperties['Productvariant'] = selectedProductVariant.title;
        }

        const warrantyItem = {
          id: warrantyVariantId,
          quantity: mainItem.quantity,
          properties: warrantyProperties
        };

        this.setLoading(true);

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              items: [mainItem, warrantyItem]
            })
          });

          const result = await response.json();

          if (!response.ok) {
            throw new Error(result.description || result.message || 'De producten konden niet aan de winkelwagen worden toegevoegd.');
          }

          window.location.assign(`${root}cart`);
        } catch (error) {
          this.showError(error.message || 'Er ging iets mis. Probeer het opnieuw.');
          this.setLoading(false);
        }
      }
    }

    customElements.define('b2c-warranty-choice', B2CWarrantyChoice);
  }



  if (!window.__b2cFinalTotalInstalled) {
    window.__b2cFinalTotalInstalled = true;

    const initializeB2CFinalTotal = (root) => {
      if (!root || root.dataset.b2cFinalTotalInitialized === 'true') return;
      root.dataset.b2cFinalTotalInitialized = 'true';

      const form = root.closest('form.js-product-form-main');
      const totalElement = root.querySelector('[data-b2c-final-total]');
      const variantScript = root.querySelector('[data-b2c-final-total-variants]');
      if (!form || !totalElement || !variantScript) return;

      let variants = [];
      try {
        variants = JSON.parse(variantScript.textContent.trim());
      } catch (error) {
        console.warn('Bar2Charge totaalprijs: productprijzen konden niet worden gelezen.', error);
      }

      const variantMap = new Map(variants.map((variant) => [String(variant.id), variant]));

      const formatMoney = (cents) => {
        const currency = root.dataset.currency || 'EUR';
        const locale = root.dataset.locale || 'nl-NL';

        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency
          }).format(Number(cents || 0) / 100);
        } catch (error) {
          return `${(Number(cents || 0) / 100).toFixed(2)} ${currency}`;
        }
      };

      const getQuantity = () => {
        const quantityInput = form.querySelector('[name="quantity"]');
        const quantity = quantityInput ? Number.parseInt(quantityInput.value, 10) : 1;
        return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
      };

      const updateTotal = () => {
        const idInput = form.querySelector('input[name="id"]');
        const variantId = idInput?.value ? String(idInput.value) : '';
        const productVariant = variantMap.get(variantId);
        const quantity = getQuantity();

        const productPrice = Number(productVariant?.price || 0) * quantity;

        const warrantyRadio = form.querySelector('.b2c-warranty-choice__radio:checked');
        const warrantyPrice = Number(warrantyRadio?.dataset.price || 0) * quantity;

        const accessoryPrice = Array.from(
          form.querySelectorAll('[data-b2c-accessory-item]:checked')
        ).reduce((sum, input) => sum + Number(input.dataset.price || 0), 0);

        totalElement.textContent = formatMoney(productPrice + warrantyPrice + accessoryPrice);
      };

      form.addEventListener('input', () => window.requestAnimationFrame(updateTotal));
      form.addEventListener('change', () => {
        window.requestAnimationFrame(updateTotal);
        window.setTimeout(updateTotal, 50);
      });

      const productRoot = root.closest('.js-product') || document;
      productRoot.addEventListener('on:variant:change', () => window.setTimeout(updateTotal, 0));
      productRoot.addEventListener('variant:change', () => window.setTimeout(updateTotal, 0));

      updateTotal();
    };

    const initializeAllB2CFinalTotals = (scope = document) => {
      scope.querySelectorAll('[data-b2c-final-total-root]').forEach(initializeB2CFinalTotal);
    };

    initializeAllB2CFinalTotals();
    document.addEventListener('shopify:section:load', (event) => initializeAllB2CFinalTotals(event.target));
  }


  if (!window.__b2cAccessoryChoiceUiInstalled) {
    window.__b2cAccessoryChoiceUiInstalled = true;

    const initializeAccessoryChoice = (root) => {
      if (!root || root.dataset.b2cUiInitialized === 'true') return;
      root.dataset.b2cUiInitialized = 'true';

      const form = root.closest('form.js-product-form-main');
      if (!form) return;

      const formatMoney = (cents) => {
        const currency = root.dataset.currency || 'EUR';
        const locale = root.dataset.locale || 'nl-NL';

        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency
          }).format(Number(cents || 0) / 100);
        } catch (error) {
          return `${(Number(cents || 0) / 100).toFixed(2)} ${currency}`;
        }
      };

      const syncVariantSelect = (select, selectAccessory = false) => {
        const targetId = select.dataset.targetInput;
        const input = targetId ? root.querySelector(`#${CSS.escape(targetId)}`) : null;
        const option = select.options[select.selectedIndex];
        const optionWrapper = select.closest('.b2c-accessory-choice__option');
        const priceElement = optionWrapper?.querySelector('[data-b2c-accessory-price]');

        if (!input || !option) return;

        input.value = option.value || '';
        input.dataset.price = option.dataset.price || '0';
        input.disabled = option.disabled === true;

        if (priceElement) {
          priceElement.textContent = `+ ${formatMoney(option.dataset.price || 0)}`;
        }

        if (selectAccessory && !input.disabled) {
          input.checked = true;
        }
      };

      root.querySelectorAll('[data-b2c-accessory-variant-select]').forEach((select) => {
        syncVariantSelect(select, false);

        select.addEventListener('click', (event) => {
          event.stopPropagation();
        });

        select.addEventListener('change', () => {
          syncVariantSelect(select, true);
        });
      });

    };

    const initializeAllAccessoryChoices = (scope = document) => {
      scope.querySelectorAll('[data-b2c-accessory-choice]').forEach(initializeAccessoryChoice);
    };

    initializeAllAccessoryChoices();
    document.addEventListener('shopify:section:load', (event) => initializeAllAccessoryChoices(event.target));
  }


  if (!window.__b2cAccessorySubmitHandlerInstalled) {
    window.__b2cAccessorySubmitHandlerInstalled = true;

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('form.js-product-form-main');
      if (!form) return;

      const accessoryRoot = form.querySelector('[data-b2c-accessory-choice]');
      if (!accessoryRoot) return;

      const selectedAccessories = Array.from(
        accessoryRoot.querySelectorAll('[data-b2c-accessory-item]:checked')
      ).filter((input) => input.value);

      if (selectedAccessories.length === 0) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const errorElement = form.querySelector('.js-form-error');
      if (errorElement) {
        errorElement.hidden = true;
        errorElement.textContent = '';
      }

      const button = form.querySelector('button[name="add"]');
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      }

      try {
        const formData = new FormData(form);
        const mainVariantId = Number(formData.get('id'));
        const quantityInput = form.querySelector('[name="quantity"]');
        const parsedQuantity = quantityInput ? Number.parseInt(quantityInput.value, 10) : 1;
        const quantity = Number.isFinite(parsedQuantity) && parsedQuantity > 0 ? parsedQuantity : 1;

        if (!mainVariantId) {
          throw new Error('Kies eerst een productuitvoering.');
        }

        const properties = {};
        for (const [key, value] of formData.entries()) {
          const propertyMatch = key.match(/^properties\[(.*)\]$/);
          if (propertyMatch && String(value).trim() !== '') {
            properties[propertyMatch[1]] = value;
          }
        }

        const mainItem = {
          id: mainVariantId,
          quantity
        };

        if (Object.keys(properties).length > 0) {
          mainItem.properties = properties;
        }

        const sellingPlan = formData.get('selling_plan');
        if (sellingPlan) {
          mainItem.selling_plan = Number(sellingPlan);
        }

        const items = [mainItem];

        const warrantyRadio = form.querySelector('.b2c-warranty-choice__radio:checked');
        const warrantyVariantId = Number(warrantyRadio?.value || 0);

        if (warrantyVariantId) {
          const warrantyRoot = form.querySelector('b2c-warranty-choice');
          const warrantyProperties = {
            'Garantie voor': warrantyRoot?.dataset.productTitle || accessoryRoot.dataset.productTitle || document.title,
            'Gekozen dekking': warrantyRadio.dataset.title || 'Verlengde garantie'
          };

          items.push({
            id: warrantyVariantId,
            quantity,
            properties: warrantyProperties
          });
        }

        selectedAccessories.forEach((input) => {
          items.push({
            id: Number(input.value),
            quantity: 1
          });
        });

        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ items })
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.description || result.message || 'De producten konden niet aan de winkelwagen worden toegevoegd.');
        }

        window.location.assign(`${root}cart`);
      } catch (error) {
        if (errorElement) {
          errorElement.textContent = error.message || 'Er ging iets mis. Probeer het opnieuw.';
          errorElement.hidden = false;
        }

        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      }
    }, true);
  }




  // Bar2Charge speciale levertijd:
  // ALLEEN het variantmetafield custom.speciale_levertijd bepaalt de groene stijl.
  // De zichtbare tekst speelt hierbij geen enkele rol.
  function b2cInitSpecialDeliveryMetafieldSync() {
    document.querySelectorAll('.js-product').forEach((productRoot) => {
      if (productRoot.dataset.b2cSpecialDeliverySync === 'true') return;
      productRoot.dataset.b2cSpecialDeliverySync = 'true';

      const dataEl = productRoot.querySelector('[data-b2c-special-delivery-variants]');
      if (!dataEl) return;

      let variants = [];

      try {
        variants = JSON.parse(dataEl.textContent || '[]');
      } catch (error) {
        console.warn('Bar2Charge speciale levertijd: variantdata konden niet worden gelezen.', error);
        return;
      }

      const variantMap = new Map(
        variants.map((variant) => [String(variant.id), variant])
      );

      const getSelectedVariantId = () => {
        const mainFormInput = productRoot.querySelector(
          '.js-product-form-main input[name="id"], form[action*="/cart/add"] input[name="id"]'
        );

        if (mainFormInput && mainFormInput.value) {
          return String(mainFormInput.value);
        }

        const urlVariant = new URL(window.location.href).searchParams.get('variant');
        if (urlVariant) return String(urlVariant);

        const deliveryBox = productRoot.querySelector('.b2c-delivery');
        if (deliveryBox?.dataset.currentVariant) {
          return String(deliveryBox.dataset.currentVariant);
        }

        return '';
      };

      const resetElement = (element, properties) => {
        if (!element) return;
        properties.forEach((property) => element.style.removeProperty(property));
      };

      const applyGreenStyle = (box) => {
        const main = box.querySelector('.b2c-delivery__main');
        const dot = box.querySelector('.b2c-delivery__dot');
        const textElement = box.querySelector('.b2c-delivery__text');
        const infoElement = box.querySelector('.b2c-delivery__info-label, .b2c-delivery__info');

        box.setAttribute('data-b2c-special-delivery', 'true');

        if (main) {
          main.style.setProperty('background', '#f2fbf4', 'important');
          main.style.setProperty('border-left', '5px solid #34c759', 'important');
        }

        if (dot) {
          dot.style.setProperty('background', '#34c759', 'important');
          dot.style.setProperty('animation', 'b2cPulseGreen 1.6s infinite', 'important');
        }

        if (textElement) {
          textElement.style.setProperty('color', '#267044', 'important');
          textElement.querySelectorAll('*').forEach((child) => {
            child.style.setProperty('color', '#267044', 'important');
          });
        }

        if (infoElement) {
          infoElement.style.setProperty('color', '#267044', 'important');
          infoElement.querySelectorAll('*').forEach((child) => {
            child.style.setProperty('color', '#267044', 'important');
          });
        }
      };

      const removeGreenStyle = (box) => {
        if (box.getAttribute('data-b2c-special-delivery') !== 'true') return;

        box.removeAttribute('data-b2c-special-delivery');

        const main = box.querySelector('.b2c-delivery__main');
        const dot = box.querySelector('.b2c-delivery__dot');
        const textElement = box.querySelector('.b2c-delivery__text');
        const infoElement = box.querySelector('.b2c-delivery__info-label, .b2c-delivery__info');

        resetElement(main, ['background', 'border-left']);
        resetElement(dot, ['background', 'animation']);

        if (textElement) {
          resetElement(textElement, ['color']);
          textElement.querySelectorAll('*').forEach((child) => {
            resetElement(child, ['color']);
          });
        }

        if (infoElement) {
          resetElement(infoElement, ['color']);
          infoElement.querySelectorAll('*').forEach((child) => {
            resetElement(child, ['color']);
          });
        }
      };

      const sync = (forcedVariantId = '') => {
        const variantId = String(forcedVariantId || getSelectedVariantId());
        const variant = variantMap.get(variantId);
        const hasSpecialDelivery =
          variant &&
          String(variant.specialDelivery || '').trim() !== '';

        productRoot.querySelectorAll('.b2c-delivery').forEach((box) => {
          if (hasSpecialDelivery) {
            applyGreenStyle(box);
          } else {
            removeGreenStyle(box);
          }
        });
      };

      // Eerste weergave.
      window.requestAnimationFrame(() => sync());

      // Variantwissel: gebruik rechtstreeks het gekozen variant-ID.
      const variantPicker = productRoot.querySelector('variant-picker');

      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', (event) => {
          const variantId = event.detail?.variant?.id || '';
          window.requestAnimationFrame(() => sync(variantId));
        });
      }

      // Fallback voor themes die een ander variant-event afvuren.
      productRoot.addEventListener('variant:change', (event) => {
        const variantId = event.detail?.variant?.id || event.detail?.id || '';
        window.requestAnimationFrame(() => sync(variantId));
      });

      // De bestaande levertijdbalk kan zichzelf na laden/variantwissel opnieuw renderen.
      // Daarom alleen de balk observeren; de beslissing blijft ALTIJD op het metafield gebaseerd.
      const observer = new MutationObserver(() => {
        window.requestAnimationFrame(() => sync());
      });

      observer.observe(productRoot, {
        childList: true,
        subtree: true
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', b2cInitSpecialDeliveryMetafieldSync, { once: true });
  } else {
    b2cInitSpecialDeliveryMetafieldSync();
  }


  } catch(e) { console.error(e); }
})();
})();
